/** القسم 2 — «رؤية استراتيجية لبناء شبكة إعلامية اقتصادية عالمية» (ملف PDF العربي). */
export const visionAr = {
  id: 'vision',
  previewCount: 6,
  navLabel: 'الرؤية الاستراتيجية',
  eyebrow: 'رؤية استراتيجية',
  title: 'رؤية استراتيجية لبناء شبكة إعلامية اقتصادية عالمية',
  subtitle: 'من برنامج تلفزيوني إلى منظومة إعلامية تقود العلاقات الاقتصادية وتفتح الأسواق.',
  blocks: [
    {
      icon: 'campaign',
      title: 'المقدمة',
      wide: true,
      paragraphs: [
        'العالم لا يحتاج إلى برنامج عقاري جديد فقط. العالم يحتاج إلى نموذج إعلامي جديد يستطيع أن يربط بين: الدول — الحكومات — المستثمرين — رؤوس الأموال — الشركات — الأسواق — الإعلام — والفرص الاقتصادية.',
        'ومن هنا تأتي فكرة مبادرة نادي حلول العقاري العالمي للإعلام الاقتصادي. الفكرة ليست إنتاج برنامج تلفزيوني تقليدي يعرض مشروعات عقارية أو يستضيف شركات للترويج لها.',
        'بل إنشاء منظومة إعلامية اقتصادية دولية تستخدم قوة الإعلام بمختلف أدواته لفتح الأسواق، وتسويق الرؤى الاقتصادية للدول، وجذب الاستثمارات، وبناء العلاقات بين المؤسسات، وإيجاد الفرص، ودعم تكوين الشراكات والصفقات، والتلفزيون هو الواجهة الرئيسية.',
      ],
      flowLabel: 'أما المنظومة الحقيقية فهي أوسع بكثير:',
      flow: [
        'التلفزيون',
        'الإعلام الرقمي',
        'وسائل التواصل الاجتماعي',
        'الصحافة',
        'الإذاعة',
        'الفعاليات',
        'العلاقات التجارية',
        'الوصول إلى الأسواق الدولية',
      ],
      flowJoin: '+',
    },
    {
      icon: 'lightbulb',
      title: 'الفكرة الكبرى',
      paragraphs: [
        'كل دولة لديها رؤية اقتصادية. السعودية لديها رؤية 2030. مصر لديها رؤية 2030. وسنغافورة لديها رؤيتها الاقتصادية والتنموية. والمملكة المتحدة لديها استراتيجياتها الاقتصادية والاستثمارية.',
        'وكل دولة تسعى إلى:',
      ],
      bullets: [
        'جذب الاستثمارات.',
        'فتح أسواق جديدة.',
        'جذب رؤوس الأموال.',
        'تنشيط قطاعات محددة.',
        'دعم الشركات الوطنية.',
        'جذب المستثمرين الدوليين.',
        'الترويج للمدن والمشروعات.',
        'بناء صورة اقتصادية دولية قوية.',
      ],
      closing:
        'وهنا يأتي دور المشروع: أن يصبح البرنامج والمنظومة الإعلامية المحيطة به أداة دولية لتسويق الرؤية الاقتصادية للدولة، ليس مجرد إعلام عن الدولة، بل إعلام يعمل من أجل اقتصاد الدولة.',
    },
    {
      icon: 'public',
      title: 'البرنامج كأداة وطنية ودولية',
      paragraphs: ['عند إطلاق البرنامج في دولة معينة، يتم بناء المحتوى حول أسئلة جوهرية:'],
      bullets: [
        'ما الذي تريد الدولة تحقيقه؟',
        'ما الذي تحتاج إلى استثماره؟',
        'ما الأسواق التي تريد الوصول إليها؟',
        'ما نوع المستثمرين الذين تبحث عنهم؟',
        'ما القطاعات التي تريد تنميتها؟',
        'ما المشروعات التي تحتاج إلى رأس مال؟',
        'ما الشركات التي تريد دخول السوق؟',
        'وما الذي يمكن أن تقدمه الدولة للمستثمر العالمي؟',
      ],
      flowLabel: 'وبالتالي يصبح البرنامج وسيلة لعرض:',
      flow: ['الرؤية', 'الفرص', 'الاستثمار', 'الأسواق', 'المشروعات', 'الشراكات'],
      flowJoin: '+',
    },
    {
      icon: 'account_tree',
      title: 'النموذج المقترح',
      wide: true,
      paragraphs: ['المشروع يقوم على معادلة بسيطة:'],
      flow: [
        'الدولة تحدد الرؤية والاحتياج',
        'الإعلام يحول الرؤية إلى قصة عالمية',
        'البرنامج يصل إلى المستثمرين والشركات',
        'الشبكة الإعلامية تفتح الأسواق',
        'اللقاءات تجمع الأطراف',
        'العلاقات تتحول إلى اجتماعات وشراكات',
        'الفرص تتحول إلى استثمارات وصفقات',
      ],
      closing: 'هذه هي الفكرة الأساسية.',
    },
    {
      icon: 'domain',
      title: 'البرنامج ليس برنامجًا عقاريًا تقليديًا',
      paragraphs: [
        'رغم أن المشروع يحمل هوية نادي حلول العقاري العالمي، فإن المحتوى لا يقتصر على العقار. العقار هو أحد أهم مكونات الاقتصاد، لكنه يمثل بوابة للدخول إلى الاقتصاد الأوسع.',
        'لذلك يمكن أن يتناول البرنامج:',
      ],
      chips: [
        'العقارات',
        'الاستثمار',
        'التمويل',
        'البنوك',
        'الصناعة',
        'السياحة',
        'التكنولوجيا',
        'الطاقة',
        'النقل',
        'المدن',
        'البنية التحتية',
        'الرياضة',
        'الشركات',
        'الأسواق المالية',
        'المشروعات الكبرى',
        'التجارة الدولية',
      ],
      closing: 'وكل ذلك من منظور: النمو الاقتصادي والاستثمار.',
    },
    {
      icon: 'travel_explore',
      title: 'القوة الحقيقية: البعد الدولي',
      paragraphs: [
        'البرنامج في دولة لا يخاطب الدولة وحدها بل يخاطب العالم. على سبيل المثال: إذا تم إطلاق «نادي حلول العقاري العالمي — السعودية» فإن البرنامج لا يستضيف السعوديين فقط، بل يمكن أن يستضيف:',
      ],
      bullets: [
        'مستثمرًا بريطانيًا.',
        'صندوقًا سنغافوريًا.',
        'شركة تركية.',
        'بنكًا دوليًا.',
        'مطورًا مصريًا.',
        'شركة تكنولوجيا عالمية.',
      ],
      closing: [
        'لأن الهدف ليس فقط: ماذا يحدث في السعودية؟ بل أيضًا: من يستطيع المشاركة في السعودية؟',
        'وفي الاتجاه المقابل، يمكن للشركات السعودية أن تظهر في برامج نادي حلول العقاري العالمي في: بريطانيا، مصر، تركيا، سنغافورة، أوروبا، آسيا، وغيرها. وهكذا يتحول البرنامج إلى منصة للوصول إلى الأسواق عبر الحدود.',
      ],
    },
    {
      icon: 'account_balance',
      title: 'الدولة ليست مجرد ضيف',
      paragraphs: [
        'في النموذج المقترح، الدولة تصبح شريكًا استراتيجيًا في المحتوى الاقتصادي. يمكن أن تبدأ المنظومة من:',
      ],
      flow: [
        'رئيس الدولة أو رئيس الحكومة',
        'الوزراء والجهات الاقتصادية',
        'هيئات الاستثمار',
        'المؤسسات المالية',
        'المستثمرين',
        'الشركات',
        'الأسواق الدولية',
      ],
      closing: 'ويتم بناء كل موسم أو مجموعة حلقات حول الأولويات الاقتصادية للدولة.',
    },
    {
      icon: 'meeting_room',
      title: 'من الحوار الإعلامي إلى غرفة العلاقات الاقتصادية',
      paragraphs: [
        'أحد أهم عناصر المشروع هو ألا تنتهي العلاقة بمجرد انتهاء الحلقة. يمكن تنظيم لقاءات مغلقة مرتبطة بالبرنامج تجمع:',
      ],
      chips: [
        'مسؤولين حكوميين',
        'مستثمرين',
        'بنوكًا',
        'صناديق استثمار',
        'شركات',
        'مستثمرين دوليين',
        'مطورين',
      ],
      listLabel: 'هذه اللقاءات يمكن أن تكون:',
      bullets: [
        'اجتماعات أعمال مغلقة.',
        'موائد استثمارية مستديرة.',
        'حوارات اقتصادية.',
        'غرف أعمال نادي حلول.',
      ],
      closing:
        'ويتم إعلاميًا تغطية الجزء المناسب منها، مع الحفاظ على خصوصية المفاوضات والصفقات. وبذلك يصبح البرنامج هو: الإعلام الذي يفتح الباب للعلاقة الاقتصادية.',
    },
    {
      icon: 'podcasts',
      title: 'الإعلام هنا ليس التلفزيون فقط',
      wide: true,
      paragraphs: [
        'التلفزيون يمثل الواجهة الرئيسية، لكن المشروع مصمم منذ البداية ليعمل كمنظومة إعلامية متكاملة، يشمل:',
      ],
      labeled: [
        { label: 'التلفزيون', text: 'البرنامج الرئيسي والبث التلفزيوني.' },
        { label: 'الإعلام الرقمي', text: 'منصة رقمية ومحتوى متكامل.' },
        { label: 'وسائل التواصل الاجتماعي', text: 'حسابات رسمية للبرنامج والدولة والسوق المستهدف.' },
        { label: 'الصحافة', text: 'تغطيات وتحليلات ومقابلات في الصحف والمواقع الكبرى.' },
        { label: 'الإذاعة', text: 'لقاءات وتغطيات وبرامج مرتبطة بالمحتوى الاقتصادي.' },
        { label: 'الفيديو والبث الرقمي', text: 'محتوى رقمي قصير ومتخصص.' },
        { label: 'الفعاليات', text: 'منتديات ولقاءات اقتصادية مرتبطة بالبرنامج.' },
        { label: 'الإعلام الاقتصادي', text: 'توزيع المحتوى على المنصات الاقتصادية الدولية.' },
      ],
    },
    {
      icon: 'bolt',
      title: 'القوة الرقمية',
      paragraphs: [
        'كل حلقة لا تنتهي بانتهاء البث، بل تتحول إلى عشرات ومئات القطع الإعلامية، مثل:',
      ],
      chips: [
        'المقابلات',
        'المقاطع القصيرة',
        'التصريحات',
        'الأرقام',
        'الفرص الاستثمارية',
        'قصص النجاح',
        'التقارير',
        'الرسوم المعلوماتية',
        'الفيديوهات القصيرة',
        'محتوى لينكدإن',
        'محتوى يوتيوب',
        'محتوى تيك توك وإنستغرام',
        'المقالات الصحفية',
      ],
      closing: 'وبالتالي يصبح البرنامج مصنعًا للمحتوى الاقتصادي وليس مجرد ساعة بث.',
    },
    {
      icon: 'view_timeline',
      title: 'الشكل المقترح للبرنامج',
      paragraphs: [
        'الشكل النهائي لكل دولة يمكن تطويره بالتعاون مع القناة والوكالة، لكن الإطار العام يمكن أن يشمل:',
      ],
      numbered: [
        { label: 'الرؤية — The Vision', text: 'رؤية الدولة وأهدافها الاقتصادية.' },
        { label: 'صناع القرار — The Decision Makers', text: 'رؤساء الدول والحكومات والوزراء والمسؤولون.' },
        { label: 'رأس المال — The Capital', text: 'البنوك والصناديق والمستثمرون.' },
        { label: 'السوق — The Market', text: 'حركة الأسواق والقطاعات والفرص.' },
        { label: 'المطورون — The Developers', text: 'المطورون والمشروعات الكبرى.' },
        { label: 'المستثمرون العالميون — Global Investors', text: 'مستثمرون من خارج الدولة.' },
        { label: 'قادة الأعمال — Business Leaders', text: 'رؤساء الشركات وكبار رجال الأعمال.' },
        { label: 'الفرصة — The Opportunity', text: 'فرص استثمارية حقيقية.' },
        { label: 'غرفة الصفقات — The Deal Room', text: 'نقاشات وفرص وشراكات محتملة.' },
        { label: 'الجسر العالمي — The Global Bridge', text: 'ربط الدولة بالأسواق الدولية.' },
      ],
    },
    {
      icon: 'tune',
      title: 'لماذا سيختلف البرنامج من دولة إلى أخرى؟',
      paragraphs: [
        'الـ Format الأساسي عالمي، لكن المحتوى والشكل المحلي قابلان للتكيف. فبرنامج «نادي حلول العقاري العالمي — السعودية» ليس بالضرورة نسخة مطابقة من «نادي حلول العقاري العالمي — مصر» أو «سنغافورة» أو «المملكة المتحدة».',
        'لأن لكل دولة:',
      ],
      chips: [
        'رؤية',
        'اقتصادًا',
        'أولويات',
        'قطاعات',
        'جمهورًا',
        'لغة',
        'ثقافة',
        'أهدافًا استثمارية',
      ],
      closing: 'لكن العلامة والهوية والمبادئ الأساسية تظل واحدة.',
    },
    {
      icon: 'verified',
      title: 'العلامة التجارية العالمية',
      paragraphs: [
        'الهدف هو بناء علامة عالمية واحدة: نادي حلول العقاري العالمي، ثم يتم تكييفها حسب السوق:',
      ],
      bullets: [
        'نادي حلول العقاري العالمي — مصر.',
        'نادي حلول العقاري العالمي — السعودية.',
        'نادي حلول العقاري العالمي — المملكة المتحدة.',
        'نادي حلول العقاري العالمي — سنغافورة.',
        'نادي حلول العقاري العالمي — تركيا.',
      ],
      closing:
        'وهكذا، مثل النماذج العالمية الناجحة التي تحافظ على هويتها الأساسية، بينما يتم تكييفها محليًا وفق طبيعة كل سوق.',
    },
    {
      type: 'parties',
      icon: 'handshake',
      title: 'نموذج الشراكة',
      intro: 'المشروع يقوم في كل سوق على ثلاثة أطراف رئيسية:',
      items: [
        {
          tag: 'أولًا',
          title: 'نادي حلول العقاري العالمي',
          lead: 'يقدم:',
          chips: [
            'الرؤية العالمية',
            'الـ Format',
            'العلامة',
            'العلاقات الدولية',
            'الوصول إلى الأسواق الخارجية',
            'الضيوف والشخصيات الدولية',
            'العلاقات مع المستثمرين والشركات',
            'الفرص العابرة للحدود',
            'الربط بين الأسواق',
          ],
        },
        {
          tag: 'ثانيًا',
          title: 'الشريك الإعلامي / الوكالة',
          lead: 'يقدم:',
          chips: [
            'الرعاة',
            'المعلنين',
            'العلاقات مع العلامات التجارية',
            'مبيعات الرعاية',
            'الشراكات التجارية للعلامات',
            'المبيعات الإعلامية',
            'العلاقات الإعلامية',
            'العلاقات مع القنوات',
            'تطوير الباقات التجارية',
            'التسويق',
            'الترويج الرقمي',
            'إدارة الحملات الإعلامية',
            'المشاركة في تطوير وتنفيذ المشروع التجاري والإعلامي',
          ],
          note: 'والهدف هو أن تكون الوكالة شريكًا في المشروع، وليس مجرد منفذ إنتاج.',
        },
        {
          tag: 'ثالثًا',
          title: 'القناة / المنصة الإعلامية',
          lead: 'يمكن أن تقدم:',
          chips: [
            'البث',
            'الإنتاج',
            'الاستوديو',
            'فريق التنفيذ',
            'التوزيع',
            'المساحات الإعلامية',
            'الدعم الترويجي',
            'المنصات الرقمية',
          ],
        },
      ],
      closing:
        'وقد تختلف العلاقة من دولة إلى أخرى، ففي بعض الأسواق يمكن أن تتولى القناة الإنتاج، وفي أسواق أخرى يمكن أن تتولى الوكالة إدارة الإنتاج بالتعاون مع القناة.',
    },
    {
      icon: 'balance',
      title: 'نموذج تجاري مفتوح',
      paragraphs: [
        'المشروع لا يفرض من البداية نسبة ثابتة على أي طرف، لأن قيمة كل طرف تختلف من دولة إلى أخرى، لكن المبدأ هو: من يصنع القيمة يشارك في القيمة.',
      ],
      labeled: [
        {
          label: 'الوكالة',
          text: 'التي تجلب: رعاة، معلنين، شراكات، قنوات، تحصل على عائد يتناسب مع دورها.',
        },
        {
          label: 'القناة',
          text: 'التي توفر: الإنتاج، البث، التوزيع، تحصل على عائد يتناسب مع دورها.',
        },
        {
          label: 'نادي حلول العقاري العالمي',
          text: 'يقدم: الملكية الفكرية، الـ Format، العلاقات الدولية، المحتوى، الوصول إلى الأسواق، الشبكة العالمية، ويحصل على عائد يتناسب مع القيمة التي يقدمها.',
        },
      ],
      closing: 'الهدف: بناء منظومة تجارية مستدامة وليس مجرد بيع وقت إعلاني.',
    },
    {
      icon: 'loyalty',
      title: 'الرعاية',
      paragraphs: ['سوق الرعاية المستهدف أكبر بكثير من شركات العقارات، يمكن أن يضم:'],
      chips: [
        'البنوك',
        'الاتصالات',
        'الطيران',
        'السيارات',
        'الفنادق',
        'التكنولوجيا',
        'التأمين',
        'الطاقة',
        'مواد البناء',
        'الأثاث',
        'الخدمات المالية',
        'شركات الاستثمار',
        'شركات التكنولوجيا العقارية',
        'الشركات الصناعية',
        'الشركات متعددة الجنسيات',
        'العلامات التجارية الكبرى',
      ],
      closing: 'وهنا تتحول الرعاية من: إعلان إلى شراكة اقتصادية.',
    },
    {
      icon: 'star',
      title: 'لماذا ستكون الرعاية جذابة؟',
      paragraphs: ['لأن الراعي لا يشتري مجرد إعلان، بل يمكن أن يحصل على:'],
      chips: [
        'حضور للعلامة التجارية — Brand Visibility',
        'حضور تنفيذي — Executive Exposure',
        'وصول إلى الجهات الحكومية — Government Access',
        'حضور دولي — International Visibility',
        'شبكة علاقات أعمال — Business Networking',
        'دخول إلى أسواق جديدة — Market Entry',
        'حضور عابر للحدود — Cross-Border Exposure',
        'قيادة فكرية — Thought Leadership',
      ],
      closing: 'وبذلك يصبح البرنامج منصة استراتيجية للعلامة التجارية.',
    },
    {
      icon: 'flag',
      title: 'البرنامج كأداة لتسويق الدولة',
      paragraphs: ['هذه من أهم ركائز المشروع، يمكن للدولة أن تستخدم البرنامج لتسويق:'],
      chips: [
        'رؤيتها الاقتصادية',
        'المدن الجديدة',
        'المشروعات الكبرى',
        'المناطق الاستثمارية',
        'السياحة',
        'الصناعة',
        'التكنولوجيا',
        'البنية التحتية',
        'الفرص الاستثمارية',
        'برامج جذب الاستثمار الأجنبي',
      ],
      closing: 'والأهم: أن الرسالة لا تبقى داخل الدولة بل تنتقل إلى الأسواق المستهدفة حول العالم.',
    },
    {
      icon: 'track_changes',
      title: 'نموذج عملي',
      labeled: [
        {
          label: 'مستثمرون آسيويون',
          text: 'إذا كانت الدولة تريد جذب مستثمرين آسيويين: يمكن أن يتم تصميم محتوى إعلامي كامل يستهدف آسيا.',
        },
        {
          label: 'رؤوس أموال خليجية',
          text: 'وإذا كانت تريد رؤوس أموال خليجية: يمكن أن يتم بناء حلقات ولقاءات وفعاليات مخصصة لذلك.',
        },
        {
          label: 'شركات أوروبية',
          text: 'وإذا كانت تريد شركات أوروبية: يتم استخدام الشبكة الإعلامية والأسواق الأوروبية للوصول إليها.',
        },
      ],
      closing: 'وهكذا يصبح الإعلام أداة للوصول إلى الأسواق.',
    },
    {
      icon: 'gavel',
      title: 'العلاقة مع الحكومات',
      paragraphs: [
        'المشروع لا يتعامل مع الحكومات باعتبارها مصدرًا للضيوف فقط، بل يمكن أن يقدم لها منصة متكاملة للتواصل مع المستثمرين والأسواق، ويمكن أن يبدأ المسار من:',
      ],
      flow: [
        'رؤية الحكومة',
        'الأولويات الاقتصادية',
        'الفرص الاستثمارية',
        'المستثمرون المستهدفون',
        'الحضور الإعلامي',
        'اجتماعات الأعمال',
        'الشراكات والاستثمارات المحتملة',
      ],
      closing: 'وهذا ما يعطي المشروع قيمة مختلفة تمامًا عن البرامج الاقتصادية التقليدية.',
    },
    {
      icon: 'corporate_fare',
      title: 'العلاقة مع الشركات',
      paragraphs: [
        'الشركات أيضًا تحصل على منصة دولية. الشركة لا تظهر فقط لتقول: «لدينا مشروع»، بل تستطيع أن تتحدث عن:',
      ],
      chips: [
        'خطتها',
        'استثماراتها',
        'توسعاتها',
        'احتياجاتها',
        'الأسواق التي تستهدفها',
        'الشراكات التي تبحث عنها',
        'التكنولوجيا التي تقدمها',
        'رؤيتها المستقبلية',
      ],
      closing:
        'وبذلك يصبح البرنامج منصة لـ: التوسع المؤسسي في الأسواق — Corporate Market Expansion.',
    },
    {
      icon: 'tv',
      title: 'من الشاشة إلى السوق',
      paragraphs: ['المعادلة الأساسية للمشروع:'],
      flow: [
        'الشاشة',
        'الوعي',
        'العلاقات',
        'الاجتماعات',
        'الفرص',
        'الشراكات',
        'الاستثمار',
        'الصفقات',
      ],
      closing:
        'وهنا تظهر القيمة الحقيقية للمشروع، فالبرنامج ليس النهاية، البرنامج هو نقطة البداية.',
    },
    {
      icon: 'hub',
      title: 'شبكة البرامج العالمية',
      paragraphs: [
        'الهدف الاستراتيجي: 100 برنامج خلال 5 سنوات، لكن الهدف ليس إنتاج 100 برنامج منفصل.',
        'الهدف هو بناء: شبكة نادي حلول الإعلامية العالمية، تتكون من برامج محلية مرتبطة بشبكة عالمية واحدة. كل برنامج يفتح سوقًا، وكل سوق يفتح علاقات، وكل علاقة يمكن أن تفتح فرصة، وكل فرصة يمكن أن تنتقل إلى سوق آخر.',
      ],
      closing: 'وهكذا يصبح التوسع تكرارًا لنموذج ناجح وليس إعادة اختراع المشروع في كل مرة.',
    },
    {
      icon: 'open_in_full',
      title: 'نموذج التوسع',
      paragraphs: ['بعد نجاح أول برنامج أو مجموعة برامج:'],
      flow: [
        'Format',
        'الدولة',
        'الوكالة',
        'القناة',
        'الرعاة',
        'الإنتاج',
        'شبكة الحكومة وقطاع الأعمال',
        'الضيوف الدوليون',
        'الفرص العابرة للحدود',
      ],
      closing:
        'ثم يتم تكرار النموذج، وهكذا يصبح التوسع Replication وليس إعادة اختراع المشروع في كل مرة.',
    },
    {
      icon: 'flag_circle',
      title: 'الهدف خلال خمس سنوات',
      paragraphs: ['الهدف هو بناء شبكة إعلامية اقتصادية عالمية تضم:'],
      bullets: [
        '100 برنامج.',
        'عشرات القنوات والمنصات.',
        'مئات الرعاة.',
        'آلاف الشركات والمؤسسات المشاركة.',
        'شبكة دولية من المستثمرين.',
        'علاقات مع الحكومات والجهات الاقتصادية.',
        'تدفقًا مستمرًا للفرص بين الأسواق.',
      ],
      closing: 'وبذلك تتحول العلامة من اسم برنامج إلى: علامة إعلامية اقتصادية عالمية.',
    },
    {
      icon: 'task_alt',
      title: 'لماذا المشروع قابل للتنفيذ؟',
      paragraphs: ['لأن عناصر البنية الأساسية موجودة بالفعل:'],
      bullets: [
        'القنوات موجودة.',
        'المنصات الرقمية موجودة.',
        'وكالات الإعلان موجودة.',
        'الرعاة موجودون.',
        'الشركات موجودة.',
        'المستثمرون موجودون.',
        'الحكومات لديها رؤى اقتصادية واضحة.',
        'وسائل الإعلام تبحث باستمرار عن محتوى جديد.',
        'العلامات التجارية تبحث عن منصات جديدة للرعاية والشراكة.',
      ],
      closing:
        'التحدي ليس في اختراع البنية، التحدي هو ربط هذه العناصر داخل نموذج واحد، وهذا هو جوهر المشروع.',
    },
    {
      icon: 'diversity_3',
      title: 'دور الشريك الإعلامي',
      paragraphs: [
        'الشريك الإعلامي المطلوب ليس مجرد: شركة إنتاج، ولا مجرد: وكالة إعلانية، بل شريك يستطيع أن يجمع بين:',
      ],
      chips: [
        'الإعلام',
        'الإعلان',
        'الرعاية',
        'الشراكات التجارية',
        'العلاقات مع القنوات',
        'الإعلام الرقمي',
        'المحتوى',
        'التطوير التجاري',
      ],
      closing: 'والأهم: لديه القدرة على تحويل الفكرة إلى مشروع تجاري قابل للتوسع.',
    },
    {
      icon: 'trending_up',
      title: 'فرصة الشريك',
      paragraphs: [
        'الشريك لا يدخل في مشروع برنامج واحد، بل يدخل في نموذج قابل للتوسع إلى: دولة، ثم عدة دول، ثم شبكة دولية. وبالتالي فإن نجاح أول برنامج يمكن أن يفتح:',
      ],
      flow: ['5 برامج', '10 برامج', '25 برنامجًا', '50 برنامجًا', '100 برنامج'],
      closing: 'وهذا يخلق للشريك نفسه مصدرًا جديدًا ومستمرًا للإيرادات والشراكات التجارية.',
    },
    {
      icon: 'auto_awesome',
      title: 'ما الذي يجعل المشروع مختلفًا؟',
      paragraphs: [
        'لأن أغلب البرامج تبدأ بالسؤال: ماذا سنعرض؟ أما هذا المشروع فيبدأ بالسؤال:',
      ],
      flow: [
        'ماذا تريد الدولة أن تحقق؟',
        'من يستطيع مساعدتها؟',
        'كيف نصل إليه؟',
        'كيف نبني العلاقة؟',
        'كيف تتحول العلاقة إلى فرصة؟',
      ],
      closing: 'وبذلك يصبح الإعلام جزءًا من العملية الاقتصادية نفسها.',
    },
    {
      icon: 'visibility',
      title: 'الرؤية النهائية',
      paragraphs: [
        'نحن لا نبني: برنامجًا تلفزيونيًا. بل نبني: منصة إعلامية اقتصادية عالمية. منصة تجمع:',
      ],
      flow: [
        'الحكومات',
        'المستثمرين',
        'رؤوس الأموال',
        'الشركات',
        'العقارات',
        'الإعلام',
        'الأسواق',
      ],
      flowJoin: '+',
      closing:
        'وتستخدم الإعلام كأداة: للتعريف، والتأثير، وفتح الأسواق، وبناء العلاقات، وتحريك الاستثمار.',
    },
    {
      icon: 'language',
      title: 'الرؤية بعيدة المدى',
      paragraphs: [
        'خلال السنوات القادمة يمكن أن يصبح نادي حلول العقاري العالمي شبكة عالمية من البرامج والمنصات والفعاليات والعلاقات الاقتصادية. ويصبح لكل دولة برنامجها:',
      ],
      chips: [
        'حلول — مصر',
        'حلول — السعودية',
        'حلول — المملكة المتحدة',
        'حلول — سنغافورة',
        'حلول — تركيا',
      ],
      closing:
        'ثم تتوسع الشبكة إلى عشرات الدول، لكن جميعها تعمل تحت: علامة عالمية واحدة ورؤية عالمية واحدة.',
    },
    {
      icon: 'flag',
      title: 'الخاتمة',
      wide: true,
      highlight: true,
      paragraphs: [
        'هذه ليست دعوة إلى إنتاج برنامج تلفزيوني جديد، إنها دعوة إلى بناء نموذج جديد للإعلام الاقتصادي العالمي. نموذج:',
      ],
      labeled: [
        { label: 'يجعل الإعلام', text: 'نافذة على الدولة.' },
        { label: 'ويجعل البرنامج', text: 'جسرًا بين الأسواق.' },
        { label: 'ويجعل العلاقات', text: 'مدخلًا إلى الأعمال.' },
        { label: 'ويجعل المحتوى', text: 'أداة لجذب الاستثمار.' },
        { label: 'ويجعل الرعاية', text: 'شراكة اقتصادية.' },
        {
          label: 'ويجعل نجاح برنامج واحد',
          text: 'قابلًا للتوسع إلى شبكة عالمية من 100 برنامج خلال خمس سنوات.',
        },
      ],
    },
  ],
};
